import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Collapse, List, ListItemButton, ListItemIcon, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { capitalize } from '../../helpers';
import classNames from 'classnames';
import { makeStyles, useTheme } from '@mui/styles';
import useMountEffect from '../../mountEffect';

const useStyles = makeStyles(theme => ({
  badge: {
    width: '20px',
    height: '20px',
    display: 'flex',
    zIndex: 1,
    flexWrap: 'wrap',
    fontSize: '0.75rem',
    alignItems: 'center',
    borderRadius: '50%',
    alignContent: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  menuLink: {
    position: 'relative',
    display: 'block',
  },
  menuItem: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  menuIcon: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  menuSubItem: {
    paddingLeft: '32px',
    paddingRight: '12px',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  menuCollapsed: {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  menuActive: {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  menuClosed: {
    backgroundColor: 'transparent',
  },
  caret: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    minWidth: 0,
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
  },
  error: {
    backgroundColor: 'error.main',
    color: 'error.contrastText',
  },
}));

const SidebarItem = ({ route, index, activeRoute, toggleMenu, currentPath }) => {
  const theme = useTheme();
  console.log('spacing', theme.spacing(2));
  const classes = useStyles();

  useMountEffect(() => {
    if (!currentPath || activeRoute === index || route.path === '/') return;
    toggleMenu(index);
  });

  const badge = badge => {
    if (!badge) return;
    const badgeClassName = classNames(classes.badge, {
      [classes[`${badge.type}`]]: badge.type !== 'default',
    });
    return (
      <Typography className={classNames(classes.badge, badgeClassName)} component='div'>
        {badge.value}
      </Typography>
    );
  };

  if (route.type === 'hidden') {
    return <></>;
  }
  if (route.type === 'external') {
    return (
      <a
        href={route.path}
        target='_blank'
        rel='noopener noreferrer'
        key={index}
        className={classes.menuLink}
      >
        <ListItemButton className={classes.menuItem}>
          <ListItemIcon>
            <route.icon className={classes.menuIcon} />
          </ListItemIcon>
          <Typography variant='body1' className='flexSpacer'>
            {capitalize(route.name)}
          </Typography>
          {badge(route.badge)}
        </ListItemButton>
      </a>
    );
  }

  if (route.type === 'submenu') {
    return (
      <div className={activeRoute === index ? classes.menuCollapsed : classes.menuClosed}>
        <ListItemButton className={classes.menuItem} key={index} onClick={() => toggleMenu(index)}>
          <ListItemIcon>
            <route.icon className={classes.menuIcon} />
          </ListItemIcon>
          <Typography variant='body1' className='flexSpacer'>
            {capitalize(route.name)}
          </Typography>
          {badge(route.badge)}
          <ListItemIcon className={classes.caret}>
            {activeRoute === index ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </ListItemIcon>
        </ListItemButton>
        <Collapse in={activeRoute === index ? true : false} timeout='auto' unmountOnExit>
          <List disablePadding>
            {route.children.map(
              (subitem, index) =>
                subitem.type !== 'hidden' && (
                  <NavLink
                    to={`${route.path ? route.path : ''}${subitem.path ? subitem.path : ''}`}
                    end
                    className={({ isActive }) =>
                      (isActive ? [classes.menuLink, classes.menuActive] : [classes.menuLink]).join(
                        ' ',
                      )
                    }
                    key={index}
                  >
                    <ListItemButton className={classes.menuSubItem}>
                      {subitem.icon && (
                        <ListItemIcon>
                          <subitem.icon className={classes.menuIcon} />
                        </ListItemIcon>
                      )}
                      <Typography variant='body1' className='flexSpacer'>
                        {capitalize(subitem.name)}
                      </Typography>
                      {badge(subitem.badge)}
                    </ListItemButton>
                  </NavLink>
                ),
            )}
          </List>
        </Collapse>
      </div>
    );
  }

  return (
    <NavLink
      to={route.path}
      end
      className={({ isActive }) =>
        (isActive ? [classes.menuLink, classes.menuActive] : [classes.menuLink]).join(' ')
      }
      key={index}
    >
      <ListItemButton className={classes.menuItem} onClick={() => toggleMenu(index)}>
        <ListItemIcon>
          <route.icon className={classes.menuIcon} />
        </ListItemIcon>
        <Typography variant='body1' className='flexSpacer'>
          {capitalize(route.name)}
        </Typography>
        {badge(route.badge)}
      </ListItemButton>
    </NavLink>
  );
};

SidebarItem.prototypes = {
  route: PropTypes.object,
  index: PropTypes.number,
  activeRoute: PropTypes.number,
  toggleMenu: PropTypes.func,
};

export default SidebarItem;
